import { render, staticRenderFns } from "./standardParameters.vue?vue&type=template&id=d2e5de5c&scoped=true"
import script from "./standardParameters.vue?vue&type=script&lang=js"
export * from "./standardParameters.vue?vue&type=script&lang=js"
import style0 from "./standardParameters.vue?vue&type=style&index=0&id=d2e5de5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e5de5c",
  null
  
)

export default component.exports